<ng-template>
  <ui-select [attr.data-test-id]="e2eTestId" [uiPlaceHolder]="placeholder | localize" [style]="{ width: '100%' }" [formControl]="formControl" [uiId]="controlId" uiSize="large">
    <ui-option *ngFor="let item of uiOptions" [uiValue]="item.value" [uiLabel]="$any(item.label) | localize"></ui-option>
  </ui-select>
</ng-template>
